// Tools public
//
// Functions, utilities, and constants used in the project.
	const CLASS_NAME_SHOW$1 = 'show'
	const CLASS_NAME_SHOW$2 = 'active'
	const CLASS_NAME_SHOW$3 = 'hidden'

	// tools-website-start
	const getSelector = (element, attribute) => {
		let selector = element.getAttribute(attribute)

		if (!selector || selector === '#') {
			let hrefAttr = element.getAttribute('href')

			if (!hrefAttr || (!hrefAttr.includes('#') && !hrefAttr.startsWith('.'))) {
				return null
			}

			if (hrefAttr.includes('#') && !hrefAttr.startsWith('#')) {
				hrefAttr = `#${hrefAttr.split('#')[1]}`
			}

			selector = hrefAttr && hrefAttr !== '#' ? hrefAttr.trim() : null
		}

		if (typeof selector === 'string' && attribute === 'id') {
			return selector.includes('#') ? selector : `#${selector}`
		}

		return selector
	}

	const getSelectorFromElement = (element, attribute) => {
		const selector = getSelector(element, attribute)

		if (selector) {
			return document.querySelector(selector) ? selector : null
		}

		return null
	}

	const onToggle = (element, nameClass = CLASS_NAME_SHOW$1) => {
		if (element === null) return null

		element.classList.toggle(`${nameClass}`)
	}

	const onShow = (element, nameClass = CLASS_NAME_SHOW$1) => {
		if (element === null) return null

		if (element.classList.contains(nameClass)) {
			return null
		}

		element.classList.add(`${nameClass}`)
	}

	const onHide = (element, nameClass = CLASS_NAME_SHOW$1) => {
		if (element === null) return null

		if (!element.classList.contains(nameClass)) {
			return null
		}

		element.classList.remove(`${nameClass}`)
	}

	const updatedAttributes = (element, attribute, value) => {
		if (element === null) return null

		if (!element.hasAttribute(attribute)) return null

		element.setAttribute(attribute, value)
	}

	const onAriaExpanded = (element) => {
		if (element.ariaExpanded === null) return null

		if (element.ariaExpanded === 'true') return (element.ariaExpanded = 'false')

		return (element.ariaExpanded = 'true')
	}

	const onStylesELement = (element, styles = '') => {
		if (element === null) return null

		element.setAttribute('style', styles)
	}

	// Const of prev-next-img-to-slick

	const SELECTOR_CURRENT_SLIDER = '.slick-current'
	const SELECTOR_THUMB_NEXT = '.carousel__thumb.thumb-next img[data-tb-img-next]'
	const SELECTOR_THUMB_PREV = '.carousel__thumb.thumb-prev img[data-tb-img-prev]'
	const SELECTOR_IMG_SLIDER = 'img[data-tb-img-slick]'
	const TIMEOUT_FADE = 200

	// prev-img-to-slick
	const getPrevImgSlick = (element) => {
		// current/prev/next-element-slider
		const CURRENT_SLIDE = element.querySelector(SELECTOR_CURRENT_SLIDER)
		if (CURRENT_SLIDE === null) return null

		const NEXT_SLIDE = CURRENT_SLIDE.nextElementSibling
		const PREV_SLIDE = CURRENT_SLIDE.previousElementSibling

		// next/prev-img-element-slider
		const NEXT_SLIDE_IMG = NEXT_SLIDE === null ? null : NEXT_SLIDE.querySelector(SELECTOR_IMG_SLIDER)
		const PREV_SLIDE_IMG = PREV_SLIDE === null ? null : PREV_SLIDE.querySelector(SELECTOR_IMG_SLIDER)

		// updated-img-elements
		const THUMB_NEXT = element.querySelector(SELECTOR_THUMB_NEXT)
		const THUMB_PREV = element.querySelector(SELECTOR_THUMB_PREV)

		// for-image-prev
		if (PREV_SLIDE === null) {
			updatedAttributes(THUMB_PREV, 'src', 'assets/images/img-slick-prev.png')
		} else {
			if (PREV_SLIDE_IMG !== null) {
				onShow(THUMB_PREV, CLASS_NAME_SHOW$3)
				updatedAttributes(THUMB_PREV, 'alt', PREV_SLIDE_IMG.getAttribute('alt'))
				updatedAttributes(THUMB_PREV, 'src', PREV_SLIDE_IMG.getAttribute('src'))

				setTimeout(() => {
					onHide(THUMB_PREV, CLASS_NAME_SHOW$3)
				}, TIMEOUT_FADE)
			}
		}

		// for-image-next
		if (NEXT_SLIDE_IMG !== null) {
			onShow(THUMB_NEXT, CLASS_NAME_SHOW$3)
			updatedAttributes(THUMB_NEXT, 'src', NEXT_SLIDE_IMG.getAttribute('src'))

			setTimeout(() => {
				onHide(THUMB_NEXT, CLASS_NAME_SHOW$3)
			}, TIMEOUT_FADE)
		} else {
			updatedAttributes(THUMB_NEXT, 'src', 'assets/images/img-slick-next.png')
		}
	}

	// next-img-to-slick
	const getNextImgSlick = (element) => {
		// current/prev/next-element-slider
		const CURRENT_SLIDE = element.querySelector(SELECTOR_CURRENT_SLIDER)
		if (CURRENT_SLIDE === null) return null

		const NEXT_SLIDE = CURRENT_SLIDE.nextElementSibling
		const PREV_SLIDE = CURRENT_SLIDE.previousElementSibling

		// next/prev-img-element-slider
		const NEXT_SLIDE_IMG = NEXT_SLIDE === null ? null : NEXT_SLIDE.querySelector(SELECTOR_IMG_SLIDER)
		const PREV_SLIDE_IMG = PREV_SLIDE === null ? null : PREV_SLIDE.querySelector(SELECTOR_IMG_SLIDER)

		// updated-img-elements
		const THUMB_NEXT = element.querySelector(SELECTOR_THUMB_NEXT)
		const THUMB_PREV = element.querySelector(SELECTOR_THUMB_PREV)

		// for-image-next
		if (NEXT_SLIDE === null) {
			updatedAttributes(THUMB_NEXT, 'src', 'assets/images/img-slick-next.png')
		} else {
			if (NEXT_SLIDE_IMG !== null) {
				onShow(THUMB_NEXT, CLASS_NAME_SHOW$3)
				updatedAttributes(THUMB_NEXT, 'src', NEXT_SLIDE_IMG.getAttribute('src'))
				updatedAttributes(THUMB_NEXT, 'alt', NEXT_SLIDE_IMG.getAttribute('alt'))

				setTimeout(() => {
					onHide(THUMB_NEXT, CLASS_NAME_SHOW$3)
				}, TIMEOUT_FADE)
			}
		}

		// for-image-prev
		if (PREV_SLIDE_IMG !== null) {
			onShow(THUMB_PREV, CLASS_NAME_SHOW$3)
			updatedAttributes(THUMB_PREV, 'src', PREV_SLIDE_IMG.getAttribute('src'))

			setTimeout(() => {
				onHide(THUMB_PREV, CLASS_NAME_SHOW$3)
			}, TIMEOUT_FADE)
		} else {
			updatedAttributes(THUMB_PREV, 'src', 'assets/images/img-slick-prev.png')
		}
	}

	// tools-website-end

	;(function () {
		'use strict'

		// Constants
		const CLASS_NAME_SHOW$1 = 'show'
		const CLASS_NAME_SHOW$2 = 'active'
		const CLASS_NAME_SHOW$3 = 'down'
		const CLASS_NAME_SHOW$4 = 'up'

		const SELECTOR_ELEMENT$1 = '#header.hero'

		let VALUE_SCROLL_TOP$1 = 0
		let VALUE_SCROLL_TOP$2 = 200

		// * Functions of project
		// *
		// * Add functions of elements, components of HTML

		// scrollW - Check scroll down or up for header styles
		const scrollW = () => {
			let SCROLL_TOP$1 = window.pageYOffset || document.documentElement.scrollTop
			let HEADER = document.querySelector(SELECTOR_ELEMENT$1)

			if (SCROLL_TOP$1 > VALUE_SCROLL_TOP$2) {
				if (SCROLL_TOP$1 > VALUE_SCROLL_TOP$1) {
					/* Code - Down Scroll */
					onHide(HEADER, CLASS_NAME_SHOW$4)
					onShow(HEADER, CLASS_NAME_SHOW$3)
				} else {
					/* Code - up Scroll */
					onHide(HEADER, CLASS_NAME_SHOW$3)
					onShow(HEADER, CLASS_NAME_SHOW$4)
				}
			} else {
				onHide(HEADER, CLASS_NAME_SHOW$3)
				onHide(HEADER, CLASS_NAME_SHOW$4)
			}

			VALUE_SCROLL_TOP$1 = SCROLL_TOP$1 <= 0 ? 0 : SCROLL_TOP$1
		}

		// * Focus
		// *
		// * Add class to parent element in to event required
		const FOCUS_ELEMENTS$1 = ['#email-signup_FNAME', '#email-signup_LNAME', '#email-signup_email_address', '.form-module__field.input input']
		const FOCUS_SELECTOR$1 = '.form-module-wrapper .field.gdpr.clearfix label'

		const FOCUS_CLASS_NAME$1 = 'focus'
		const FOCUS_CLASS_NAME$2 = 'checked'
		const FOCUS_CLASS_NAME$3 = 'error'

		const focusParent = () => {
			FOCUS_ELEMENTS$1.forEach((element) => {
				let input = document.querySelector(element)
				if (input === null) return null

				let parent_element

				input.addEventListener('focus', function (event) {
					event.preventDefault()

					parent_element = input.parentElement
					if (parent_element === null) return null

					onShow(parent_element, FOCUS_CLASS_NAME$1)
				})

				input.addEventListener('blur', function (event) {
					if (input.value !== '') return null

					event.preventDefault()

					parent_element = input.parentElement
					if (parent_element === null) return null

					onHide(parent_element, FOCUS_CLASS_NAME$1)
				})
			})
		}

		// * Toggle
		// *
		// * Collapse, Accordion and expand elements
		const TOGGLE_SELECTOR$1 = '[data-tb-toggle="collapse"]'
		const TOGGLE_SELECTOR$2 = '[data-tb-toggle="accordion"]'
		const TOGGLE_SELECTOR$3 = '.js-accordion-item.open'
		const TOGGLE_SELECTOR$4 = '[data-tb-toggle="dropdown"]'
		const TOGGLE_ATTRIBUTE$1 = 'data-tb-target'
		const TOGGLE_CLASS_NAME$1 = 'active'
		const TOGGLE_CLASS_NAME$2 = 'show'
		const TOGGLE_CLASS_NAME$3 = 'open'
		const TOGGLE_CLASS_NAME$4 = 'js-accordion-copy'

		const collapse = () => {
			let collapse = document.querySelectorAll(`${TOGGLE_SELECTOR$1}`)

			collapse.forEach((element) => {
				let selector = getSelectorFromElement(element, TOGGLE_ATTRIBUTE$1)

				if (selector) {
					let target = document.querySelector(selector)

					element.addEventListener('click', function (event) {
						event.preventDefault()

						onToggle(target, TOGGLE_CLASS_NAME$2)
						onToggle(element, TOGGLE_CLASS_NAME$3)
						onAriaExpanded(element)
					})
				}

				return null
			})
		}

		const accordion = () => {
			let elements = document.querySelectorAll(TOGGLE_SELECTOR$2)
			let clickParent, height, copy, elementsOpen
			let openParent, openCopy

			elements.forEach((element) => {
				element.addEventListener('click', function () {
					// Current parent to open
					clickParent = element.parentElement
					height = clickParent.getElementsByClassName('wrap').length > 0 ? clickParent.getElementsByClassName('wrap')[0].clientHeight : 0
					copy = clickParent.getElementsByClassName(TOGGLE_CLASS_NAME$4)[0]

					if (clickParent.classList.contains(TOGGLE_CLASS_NAME$3)) {
						onHide(clickParent, TOGGLE_CLASS_NAME$3)
						copy.style.height = `0`
					} else {
						onShow(clickParent, TOGGLE_CLASS_NAME$3)
						copy.style.height = `${height}px`
					}

					// Close items to open
					elementsOpen = document.querySelectorAll(TOGGLE_SELECTOR$3)

					elementsOpen.forEach((itemOpen) => {
						if (itemOpen !== clickParent) {
							openCopy = itemOpen.getElementsByClassName(TOGGLE_CLASS_NAME$4)[0]

							onHide(itemOpen, TOGGLE_CLASS_NAME$3)
							openCopy.style.height = `0px`
						}
					})
				})
			})
		}

		const dropdown = () => {
			let elements = document.querySelectorAll(TOGGLE_SELECTOR$4)
			let selector, target

			elements.forEach((element) => {
				element.addEventListener('click', function (event) {
					event.preventDefault()
					selector = getSelectorFromElement(element, TOGGLE_ATTRIBUTE$1)

					if (selector) {
						target = document.querySelector(selector)

						onToggle(element, TOGGLE_CLASS_NAME$3)

						if (element.classList.contains(TOGGLE_CLASS_NAME$3)) {
							target.style.paddingBottom = `16px`
							target.style.height = `${target.scrollHeight + 32}px`
						} else {
							target.style.padding = `0px`
							target.style.height = `0px`
						}
					}
				})
			})
		}

		// * Overflow
		// *
		// * Overflow elements in event click
		const OVERFLOW_SELECTOR$1 = '[data-tb-overflow]'
		const OVERFLOW_ATTRIBUTE$1 = 'data-tb-overflow'
		const OVERFLOW_CLASS_NAME$1 = 'overflow-element'

		const overflow = () => {
			let overflow = document.querySelectorAll(`${OVERFLOW_SELECTOR$1}`)

			overflow.forEach((element) => {
				let selector = getSelectorFromElement(element, OVERFLOW_ATTRIBUTE$1)

				if (selector) {
					let target = document.querySelector(selector)

					element.addEventListener('click', function (event) {
						event.preventDefault()

						onToggle(target, OVERFLOW_CLASS_NAME$1)
					})
				}

				return null
			})
		}

		// * Events in Hero
		// *
		// * Overflow elements in event click
		const HERO_SELECTOR$1 = '#header.hero'
		const HERO_SELECTOR$2 = '.hero__item.hero__menu'
		const HERO_SELECTOR$3 = '[data-tb-booking="close"]'
		const HERO_SELECTOR$4 = '[data-tb-booking="open"]'
		const HERO_SELECTOR$5 = '[data-tb-nav-mobile="close"]'
		const HERO_SELECTOR$6 = '[data-tb-nav-mobile="open"]'
		const HERO_SELECTOR$7 = '[data-tb-mobile="menu"]'
		const HERO_CLASS_NAME$1 = 'open-menu'
		const HERO_CLASS_NAME$2 = 'open-booking'
		const HERO_CLASS_NAME$3 = 'open'
		const HERO_CLASS_NAME$4 = 'down'
		const HERO_CLASS_NAME$5 = 'show'

		const eventsHeader = () => {
			let header = document.querySelector(HERO_SELECTOR$1)
			let actionMenu = document.querySelector(HERO_SELECTOR$2)
			let actionBookClose = document.querySelector(HERO_SELECTOR$3)
			let actionBookOpen = document.querySelector(HERO_SELECTOR$4)
			let actionNavClose = document.querySelector(HERO_SELECTOR$5)
			let actionNavOpen = document.querySelector(HERO_SELECTOR$6)
			let actionNavMobile = document.querySelector(HERO_SELECTOR$7)

			if (actionMenu !== null && header !== null) {
				actionMenu.addEventListener('click', function (event) {
					onToggle(header, HERO_CLASS_NAME$1)
					if (actionMenu.dataset.tbText !== undefined) {
						const textHero = actionMenu.dataset.tbText == 'Menu' ? 'Close' : 'Menu'
						actionMenu.dataset.tbText = textHero
					}
				})
			}

			if (actionBookClose !== null) {
				actionBookClose.addEventListener('click', function (event) {
					// Add class to header
					onShow(header, HERO_CLASS_NAME$2)
					onShow(actionBookOpen, HERO_CLASS_NAME$3)
				})
			}

			if (actionBookOpen !== null) {
				actionBookOpen.addEventListener('click', function (event) {
					// Remove class to header
					onHide(header, HERO_CLASS_NAME$2)
					onHide(actionBookOpen, HERO_CLASS_NAME$3)
				})
			}

			if (actionNavClose !== null) {
				actionNavClose.addEventListener('click', function (event) {
					// Add class to header
					onShow(header, HERO_CLASS_NAME$1)
					onShow(actionNavOpen, HERO_CLASS_NAME$3)
					onHide(actionNavMobile, HERO_CLASS_NAME$5)
				})
			}

			if (actionNavOpen !== null) {
				actionNavOpen.addEventListener('click', function (event) {
					// Remove class to header
					onHide(header, HERO_CLASS_NAME$1)
					onHide(actionNavClose, HERO_CLASS_NAME$3)
					onShow(actionNavMobile, HERO_CLASS_NAME$5)
				})
			}
		}

		// * Inner Texts
		// *
		// * Add texts to elements HTML

		// constants
		const INNER_TEXT_SELECTOR$1 = '.footer #email-signup'
		const INNER_TEXT_SELECTOR$2 = '.gdpr-wrap'
		const INNER_TEXT_SELECTOR$3 = '#attractions'
		const INNER_TEXT_ELEMENTS$1 = ['#signupformButton', '.btn']

		// movePoliciesForm - Move policies out of '.email-signup' form.
		const movePoliciesForm = () => {
			let FORM_MAIL = document.querySelector(INNER_TEXT_SELECTOR$1)
			let POLICIES = FORM_MAIL !== null ? FORM_MAIL.querySelector(INNER_TEXT_SELECTOR$2) : null

			if (FORM_MAIL !== null && POLICIES !== null) {
				FORM_MAIL.appendChild(POLICIES)
			}
		}

		// addSpan - Add span to elements
		const addSpan = () => {
			let attractions_page = document.querySelector(INNER_TEXT_SELECTOR$3)
			let elements, text_element

			if (attractions_page !== null) {
				setTimeout(() => {
					INNER_TEXT_ELEMENTS$1.forEach((selector) => {
						elements = document.querySelectorAll(selector)

						elements.forEach((element) => {
							text_element = element.innerHTML
							element.innerHTML = '<span>' + text_element + '</span>'
						})
					})
				}, 800)
			} else {
				INNER_TEXT_ELEMENTS$1.forEach((selector) => {
					elements = document.querySelectorAll(selector)

					elements.forEach((element) => {
						text_element = element.innerHTML
						element.innerHTML = '<span>' + text_element + '</span>'
					})
				})
			}
		}

		// * Menu
		// *
		// * Sub menu, menu and others
		const MENU_SELECTOR$1 = '.privary-navigation .privary-navigation__list > .privary-navigation__item > a'
		const MENU_SELECTOR$2 = '.submenu.privary-navigation__submenu'
		const MENU_CLASS_NAME$1 = 'open-menu'
		const MENU_CLASS_NAME$2 = 'show-menu'

		const openSubMenu = () => {
			let sub_menus = document.querySelectorAll(MENU_SELECTOR$1)
			let sub_menu, parent_menu

			sub_menus.forEach((item) => {
				item.addEventListener('click', function (event) {
					parent_menu = item.parentElement
					if (parent_menu === null) return null

					sub_menu = parent_menu.querySelector(MENU_SELECTOR$2)
					if (sub_menu === null) return null

					event.preventDefault()

					onToggle(parent_menu, MENU_CLASS_NAME$1)
					onToggle(sub_menu, MENU_CLASS_NAME$2)

					if (sub_menu.classList.contains(MENU_CLASS_NAME$2)) {
						sub_menu.style.height = `${sub_menu.scrollHeight}px`
					} else {
						sub_menu.removeAttribute('style')
					}

					// ? Refactor code with animation FadeIn
					// ? Created function FadeIn of Jquery
				})
			})
		}

		// * Sliders
		// *
		// * Functions for sliders of project

		// constants
		const SLIDER_SELECTOR$1 = '.sym-slides-general'
		const SLIDER_SELECTOR$2 = '.slider__reviews'
		const SLIDER_SELECTOR$3 = '.slider__single'
		const SLIDER_SELECTOR$4 = '.slider__gallery'
		const SLIDER_SELECTOR$5 = '.slider__carousel'
		const SLIDER_SELECTOR$6 = '.slider__figures-list'
		const SLIDER_SELECTOR$7 = '.slider__rooms'
		const SLIDER_SELECTOR$8 = '.home-slides'
		const SLIDER_SELECTOR$9 = '.single-quad__slider'
		const SLIDER_SELECTOR$10 = '.dropdown-content__slider'
		const SLIDER_SELECTOR$11 = '.slider__reviews-bf'

		// slickGeneral
		const slickGeneral = () => {
			$(SLIDER_SELECTOR$1).slick({
				infinite: false,
				arrows: false,
				dots: true,
				adaptiveHeight: true,
			})
		}

		// slickReviews
		const slickReviews = () => {
			$(SLIDER_SELECTOR$2).slick({
				infinite: true,
				arrows: false,
				dots: true,
			})
		}

		// slickSingle
		const slickSingle = () => {
			$(SLIDER_SELECTOR$3).slick({
				fade: true,
				cssEase: 'linear',
				arrows: true,
				dots: false,
			})
		}

		// slickSingle
		const slickGallery = () => {
			$(SLIDER_SELECTOR$4).slick({
				arrows: true,
				dots: false,
				fade: true,
				infinite: true,
			})
		}

		// slickCarrusel
		const slickCarrusel = () => {
			let ACTION_PREV, ACTION_NEXT
			const SLIDER_BOX = '.carousel__items'
			const SLIDERS_CARRUSEL = document.querySelectorAll(SLIDER_SELECTOR$5)

			SLIDERS_CARRUSEL.forEach((carousel) => {
				$(carousel).slick({
					arrows: true,
					fade: true,
					infinite: true,
					slide: SLIDER_BOX,
					responsive: [
						{
							breakpoint: 990,
							settings: {
								adaptiveHeight: true,
							},
						},
					],
				})

				ACTION_PREV = carousel.querySelector('button.slick-prev')
				ACTION_NEXT = carousel.querySelector('button.slick-next')

				ACTION_PREV.addEventListener('click', () => {
					getPrevImgSlick(carousel)
				})
				ACTION_NEXT.addEventListener('click', () => {
					getNextImgSlick(carousel)
				})

				setTimeout(() => {
					getPrevImgSlick(carousel)
					getNextImgSlick(carousel)
				}, 100)
			})
		}

		// slickList
		const slickList = () => {
			const SLIDER_BOX = '.list__images'

			$(SLIDER_SELECTOR$6).slick({
				fade: true,
				cssEase: 'linear',
				arrows: true,
				dots: false,
				slide: SLIDER_BOX,
			})
		}

		// slickRooms
		const slickRooms = () => {
			const SLIDER_BOX = '.accommodations__images'

			$(SLIDER_SELECTOR$7).slick({
				fade: true,
				cssEase: 'linear',
				arrows: true,
				dots: false,
				slide: SLIDER_BOX,
			})
		}

		// slickHome
		const slickHome = () => {
			$(SLIDER_SELECTOR$8).slick({
				fade: true,
				cssEase: 'linear',
				arrows: false,
				dots: false,
				autoplay: true,
				autoplaySpeed: 4000,
			})
		}

		const slickSingleQuad = () => {
			$(SLIDER_SELECTOR$9).slick({
				fade: true,
				cssEase: 'linear',
				arrows: true,
				dots: false,
			})
		}

		const slickDropdown = () => {
			$(SLIDER_SELECTOR$10).slick({
				fade: true,
				cssEase: 'linear',
				arrows: false,
				dots: false,
			})
		}

		// slickReviewsBf
		const slickReviewsBf = () => {
			$(SLIDER_SELECTOR$11).slick({
				infinite: true,
				arrows: false,
				dots: true,
				fade: true,
			})
		}

		// * RellaxJs
		// *
		// * Effect parallax with library RellaxJs
		const RELLAX_SELECTOR$1 = '[data-tb-rellax="image"]'
		const RELLAX_SELECTOR$2 = '[data-tb-rellax="icon"]'
		const RELLAX_SELECTOR$3 = '[data-tb-rellax="article"]'
		const MOBILE = 640
		const TABLET = 840

		const rellaxImages = () => {
			let rellax = new Rellax(RELLAX_SELECTOR$1, {
				center: true,
				breakpoints: [640, 840],
			})
		}

		const rellaxIcon = () => {
			let rellax = new Rellax(RELLAX_SELECTOR$2, {
				center: true,
				breakpoints: [640, 840],
			})
		}

		const rellaxArticle = () => {
			let rellax = new Rellax(RELLAX_SELECTOR$3, {
				center: true,
				breakpoints: [640, 840],
			})
		}

		// * Scroll Efect & Hash
		// *
		// * Scroll efect to anchor
		const SCROLL_SELECTOR_DATA$1 = '[data-tb-scroll="scroll-down"]'
		const SCROLL_SELECTOR_DATA$2 = '[data-tb-scroll="scroll-hash"]'
		const SCROLL_SELECTOR_DATA$3 = '[data-tb-scroll="scroll-hash-on-click"]'
		const SCROLL_ATTRIBUTE$1 = 'id'
		const SCROLL_ATTRIBUTE$2 = 'href'
		const SCROLL_PARAMS$1 = 'post'
		const SCROLL_PARAMS$2 = 'link'

		// scrollDown
		const scrollDown = () => {
			let scrolldown = document.querySelectorAll(SCROLL_SELECTOR_DATA$1)

			scrolldown.forEach((element) => {
				let selector = getSelectorFromElement(element)

				if (selector) {
					let target = document.querySelector(selector)

					element.addEventListener('click', function (event) {
						event.preventDefault()

						// window.scrollTo({
						// 	top: 0,
						// 	behavior: 'smooth',
						// })

						$('html, body').animate({ scrollTop: $(target).offset().top - 0 }, 800)
					})
				}

				return null
			})
		}

		// scrollToHash
		const scrollToHash = () => {
			if (window.location.hash) {
				let currentHash = window.location.hash
				let elements = document.querySelectorAll(SCROLL_SELECTOR_DATA$2)
				let selector, target

				elements.forEach((element) => {
					selector = getSelectorFromElement(element, SCROLL_ATTRIBUTE$1)

					if (selector === currentHash) {
						target = document.querySelector(selector)

						window.scrollTo({
							top: target.offsetTop,
							behavior: 'smooth',
						})
					}
				})
			}

			return null
		}

		// scrollToSearch
		// * Simulate clic in item facybox by search params
		const scrollToSearch = () => {
			if (window.location.search) {
				const url = window.location.search.slice(1)
				if (url === null) return null

				// * Decode URL Base64
				let decodeURL = atob(url)
				// * Search params
				const urlParams = new URLSearchParams(decodeURL)
				const post = urlParams.get(SCROLL_PARAMS$1)
				const link = urlParams.get(SCROLL_PARAMS$2)
				let target

				if (post !== null) {
					target = document.querySelector(post) !== null ? document.querySelector(post) : null

					if (target) {
						$('html, body').animate({ scrollTop: $(target).offset().top - 0 }, 800)

						setTimeout(() => {
							if (link !== null) {
								target = document.querySelector(link)
								if (target) {
									target.click()
								}
							}
						}, 800)
					}
				}
			}

			return null
		}

		// * DatePicker
		// *
		// * Functions for datepciker in project

		const SELECTOR_DATEPICKER$1 = '#booking__calendars'

		const SELECTOR_DATE$1 = '#arrive'
		const SELECTOR_DATE$2 = '#depart'
		const SELECTOR_DATE$3 = '#altDates'

		let opened = 0
		let start = $(SELECTOR_DATE$1).attr('value')
		let end = $(SELECTOR_DATE$2).attr('value')

		const datepickerBooking = () => {
			$(SELECTOR_DATEPICKER$1).datepicker({
				dateFormat: 'yy-mm-dd',
				numberOfMonths: 2,
				minDate: new Date(),
				beforeShowDay: function (date) {
					setTimeout(function() {
						document.querySelectorAll('.ui-datepicker-calendar td a').forEach(e => {
							e.setAttribute('tabindex', '-1');
						})
					}, 1000);
					$.datepicker._defaults.dateFormat = 'yy-mm-dd'

					let startDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start)

					let endDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end)

					if (date.getTime() == startDate.getTime()) {
						return [true, 'startday']
					} else {
						if (date.getTime() == endDate.getTime()) {
							return [true, 'endday']
						} else {
							if (date.getTime() > startDate.getTime() && date.getTime() < endDate.getTime()) {
								return [true, 'days']
							} else {
								return [true, '']
							}
						}
					}
				},
				onSelect: function (date) {
					let arrive = $.datepicker.parseDate($.datepicker._defaults.dateFormat, start)
					let departure = $.datepicker.parseDate($.datepicker._defaults.dateFormat, end)
					let selectedDate = $.datepicker.parseDate($.datepicker._defaults.dateFormat, date)

					if (opened == 0) {
						opened = 1
						start = date
						end = date
					} else {
						opened = 0
						if (selectedDate <= arrive) {
							end = start
							start = date
						} else {
							end = date
						}
					}

					$(SELECTOR_DATE$1).attr('value', start)
					$(SELECTOR_DATE$2).attr('value', end)

					let SplitArrive = start.split('-')
					let SplitDeparture = end.split('-')

					$(SELECTOR_DATE$3).attr(
						'value',
						SplitArrive[1] + // Month
							'/' +
							SplitArrive[0] + // Day
							'/' +
							SplitArrive[2] + // Year
							' - ' +
							(SplitDeparture[1] + // Month
								'/' +
								SplitDeparture[0] + // Day
								'/' +
								SplitDeparture[2]) // Year
					)
				},
			})
		}

		// * SVG Animations
		// *
		// * Animations svg with library 'animejs.com'
		const ANIMATION_SELECTOR$1 = '#home.home'

		const animateWave = () => {
			let pageHome = document.querySelector(ANIMATION_SELECTOR$1)
			if (pageHome !== null && screen.width > 1024) {
				anime({
					targets: '.wave__quad-default path',
					d: [
						//2
						{
							value: 'm-1 3039h1921v-370.55s-251.37 57.708-561.45 88.827c-280 28.1-551.01-61.043-784.1-80.626-370.79-31.149-575.45 79.767-575.45 79.767z',
						},
						//3
						{
							value: 'm-1 3039h1921v-355.25s-130.98-68.268-564 51.855c-274.89 76.255-551.17 4.5189-781.55-36.004-409.03-71.946-575.45 23.671-575.45 23.671z',
						},
						//4
						{
							value: 'm-1 3039h1921v-329.76s-248.37-101.02-560.17 2.1335c-276.49 91.474-558.94 68.53-786.65 14.992-409.03-96.169-574.18-36.249-574.18-36.249z',
						},
						//5
						{
							value: 'm-1 3039h1921v-302.98s-389.88-103.57-560.17-47.588c-276.66 90.956-699.56 105.69-785.38 64.713-174.55-83.341-575.45-84.695-575.45-84.695z',
						},
						//6
						{
							value: 'm-1 3039h1921v-286.98s-395.91-75.651-562.72-80.161c-126.06-3.4084-598.55 144.92-782.83 96.586-145.64-38.202-575.45-87.994-575.45-87.994z',
						},
						//7
						{
							value: 'm-1 3039h1921v-282.58s-400.53-43.997-565.27-70.536c-108.21-17.432-568.48 53.98-779 84.012-163.44 23.316-576.73-69.046-576.73-69.046z',
						},
						//8
						{
							value: 'm-1 3039h1921v-297.88s-398.54-8.8479-562.72-38.663c-187.26-34.006-579.59-33.576-781.55 33.016-275.64 90.885-576.73-0.2012-576.73-0.2012z',
						},
						//9
						{
							value: 'm-1 3039h1921v-323.38s-399.62 53.022-561.45 12.333c-180.88-45.48-591.99-82.452-782.83-34.554-236.44 59.344-576.73 63.018-576.73 63.018z',
						},
						//10
						{
							value: 'm-1 3039h1921v-370.55s-283.91 87.968-561.45 81.177c-181.09-4.431-591.06-104.13-784.1-72.801-203.13 32.962-575.45 79.592-575.45 79.592z',
						},
						//1
						{
							value: 'm-1 3039h1921v-393.5s-261.28 110.92-572.92 110.5c-258.33-0.3451-536.16-86.604-770.08-87-326.16-0.5518-578 110-578 110z',
						},
					],
					loop: true,
					easing: 'linear',
					duration: '9000',
				})
			}
		}

		// * Headlines
		// *
		// * Add headline in page specif
		// * Remove function for add title in gallery of mobile
		// * Ref: #426 to QA
		// const HEADLINE_SELECTOR$1 = '#gallery.gallery'
		// const HEADLINE_CONTAINER$1 = '.my-gallery.gallery-mobile'

		// headlineGallery
		// const headlineGallery = () => {
		// 	// Valid exist to h1 tag and container
		// 	let gallery_container = document.querySelector(HEADLINE_CONTAINER$1)
		// 	let headline_page = document.getElementsByTagName('h1')
		// 	if (gallery_container === null || headline_page.length !== 0) return null

		// 	// Valid page
		// 	let gallery_page = document.querySelector(HEADLINE_SELECTOR$1)
		// 	if (gallery_page === null) return null

		// 	let html_insert = `
		// 	<h1 class="gallery-mobile__title">Gallery
		// 		<span class="icon-star star-small">
		// 			<svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 57 57"><defs><clipPath id="icon-start-784525"><path d="m26.5 0 4.77 21.73L53 26.5l-21.73 4.77L26.5 53l-4.77-21.73L0 26.5l21.73-4.77z" fill="#fff"></path></clipPath></defs><path d="m26.5 0 4.77 21.73L53 26.5l-21.73 4.77L26.5 53l-4.77-21.73L0 26.5l21.73-4.77z" fill="none" stroke="currentColor" stroke-miterlimit="20" stroke-width="4" clip-path="url(&quot;#icon-start-784525&quot;)"></path></svg>
		// 		</span>
		// 		<span class="icon-star star-medium">
		// 			<svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 57 57"><defs><clipPath id="icon-start-745197"><path d="m26.5 0 4.77 21.73L53 26.5l-21.73 4.77L26.5 53l-4.77-21.73L0 26.5l21.73-4.77z" fill="#fff"></path></clipPath></defs><path d="m26.5 0 4.77 21.73L53 26.5l-21.73 4.77L26.5 53l-4.77-21.73L0 26.5l21.73-4.77z" fill="none" stroke="currentColor" stroke-miterlimit="20" stroke-width="4" clip-path="url(&quot;#icon-start-745197&quot;)"></path></svg>
		// 		</span>
		// 		<span class="icon-star star-large">
		// 			<svg xmlns="http://www.w3.org/2000/svg" viewBox="-2 -2 57 57"><defs><clipPath id="icon-start-342081"><path d="m26.5 0 4.77 21.73L53 26.5l-21.73 4.77L26.5 53l-4.77-21.73L0 26.5l21.73-4.77z" fill="#fff"></path></clipPath></defs><path d="m26.5 0 4.77 21.73L53 26.5l-21.73 4.77L26.5 53l-4.77-21.73L0 26.5l21.73-4.77z" fill="none" stroke="currentColor" stroke-miterlimit="20" stroke-width="4" clip-path="url(&quot;#icon-start-342081&quot;)"></path></svg>
		// 		</span>
		// 	</h1>`

		// 	gallery_container.insertAdjacentHTML('beforebegin', html_insert)
		// }

		// * Content Loaded
		// *
		// * DOM Content Loaded is ready available
		// * @param {*} callback

		const onDOMLoaded = (callback) => {
			if (document.readyState === 'complete' || document.readyState === 'interactive') {
				document.addEventListener('DOMContentLoaded', () => {
					setTimeout(callback, 1)
				})
			} else {
				document.addEventListener('DOMContentLoaded', callback)
			}
		}

		onDOMLoaded(
			// * This function add a class to header when scroll down the page
			// * and change the logo by a new file if needed depending of mockup

			scrollW(),
			window.addEventListener('scroll', function () {
				scrollW()
			}),

			// Inner text
			movePoliciesForm(),
			addSpan(),

			// Focus
			focusParent(),

			// Toggle
			collapse(),
			accordion(),
			dropdown(),

			// Overflow
			overflow(),

			// Events of Hero
			eventsHeader(),

			// Menu
			openSubMenu(),

			// Sliders
			slickGeneral(),
			slickReviews(),
			slickSingle(),
			slickGallery(),
			slickCarrusel(),
			slickList(),
			slickRooms(),
			slickHome(),
			slickSingleQuad(),
			slickDropdown(),
			slickReviewsBf(),

			// RellaxJs
			rellaxImages(),
			rellaxIcon(),
			rellaxArticle(),

			// Scroll
			scrollDown(),
			scrollToHash(),
			scrollToSearch(),

			// DatePicker
			datepickerBooking(),

			// Svg Animations
			animateWave()

			// HeadlineGallery
			// headlineGallery(),
		)
	})()